import type { BigFraction } from "./BigFraction.js";
import { FRACTION_ZERO } from "./fraction.js";

export const divide = (
  numerator: BigFraction | null,
  denominator: BigFraction | null,
) => {
  if (
    numerator == null ||
    denominator == null ||
    // inspired by Rust's `checked_div`, return null (aka None) when dividing by 0
    denominator.equals(FRACTION_ZERO)
  ) {
    return null;
  }

  return numerator.div(denominator);
};
